module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAABGdBTUEAALGPC/xhBQAAARxJREFUKBV1UD1LA0EQndm9HNx+5AoxpaSysjO/QVBbKystU5gmXH+YRsTewsbWH6D5CTZaW2sZxEPEUwO7k9mIcofrwiyzs+/Nm3kAkWOUOQ4R+QLRLJZlKUxmRoLETYiQh1oTg7nKB044zUUkTwdIeA0SZkuQgx4h7aLAS36T9PId1bf0nPF+Cfr3oqDUSQAEJzit69f7GFbrfIvIrxHhAyJut+aLERjczyidctNB+G8RiNtobQtjzOoPmbs+fuB8h1e4+0Ow2g7TNLli3qG1dl1n+pRIzOr67QJRfLYIbOGeh+S2qqqnohifOUdHsiNPEP2GUvnmr6JS3QmA/2JpdsrzrJHjYZ+9eWHlbrD1nBd5ZhhGoM0Sse8rC/oTW3JnZao1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/decoracion.png
// module id = 500
// module chunks = 0